import { UserLogoutResponseBody } from '../types/generated/logout_post.response';
import apiEndpoints from '../../apiEndpoints';
import { fetcher } from '../utils/fetchers/fetcher';

export const requestLogout = (
  token: string | null,
  forceHeader?: string
): Promise<UserLogoutResponseBody> =>
  fetcher<UserLogoutResponseBody>(
    apiEndpoints.routes.logout,
    'POST',
    token,
    forceHeader
  );
